export default __webpack_public_path__ + "static/media/361.4751e9d3.JPG";